import { Component, inject } from '@angular/core';
import { MovilizationTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MovilizationTypeCreateDto,
  MovilizationTypeDto,
  MovilizationTypeExcelDownloadDto,
  MovilizationTypeUpdateDto,
} from '../proxy/general/dtos/movilization-type';
import { MOVILIZATIONTYPE_CONFIG, MOVILIZATIONTYPE_FIELDS } from './movilization-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-movilization-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MovilizationTypeService, ConfirmationService],
  templateUrl: './movilization-type.html',
  styleUrl: './movilization-type.scss',
})
export class MovilizationType extends BaseCrudComponent<
  MovilizationTypeDto,
  MovilizationTypeCreateDto,
  MovilizationTypeUpdateDto,
  MovilizationTypeExcelDownloadDto
> {
  service = inject(MovilizationTypeService);
  config = MOVILIZATIONTYPE_CONFIG;
  fields = MOVILIZATIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: MovilizationTypeDto): MovilizationTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MovilizationType';
  }
}
